// src/components/icons/HomeIcon.js
/* ------------------------------------------------------------------ */
/* HomeIcon – house glyph linking back to the dashboard                */
/* ------------------------------------------------------------------ */
/**
 * @param {object} props  Regular SVG props (className, onClick, …)
 * @returns {JSX.Element}
 */
export const HomeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    className="h-8 w-auto fill-tertiary cursor-pointer"
    {...props}
  >
    <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560zm-80 80v-480l320-240 320 240v480H520v-240h-80v240zm320-350" />
  </svg>
);
